import * as React from 'react';
import { LocalizationLoader } from '../../commonInfra/services/LocalizationLoader';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';

export function SearchMicroViewHost(props: any): JSX.Element {
    const rootElementRef = React.useRef(null);

    React.useEffect(() => {
        if (rootElementRef && rootElementRef.current) {
            const locale = getLocale();
            loadScript(`/search-dist/compiled-locales/messages.${locale}.js`);
            loadScript(`/search-dist/compiled-locales/formatters-and-parsers.${locale}.js`);
            loadScript('/search-microview.js');
        }

        return () => {
        };
    }, []);

    return <div id='SearchMicroViewHost' ref={rootElementRef}>
        Loading....
    </div>;

    function loadScript(url: string): void {
        let scriptTag = document.createElement('SCRIPT');
        scriptTag.setAttribute('src', url);
        rootElementRef.current.appendChild(scriptTag);
    }

    function getLocale(): string {
        const sessionManagementService: SessionManagementService = getSessionManagementServiceInstance();
        const language = sessionManagementService.sessionLanguage() ?? ServerSettingsUnauthenticated.serverLanguage();
        const localeResult = LocalizationLoader.selectLocaleOrDefault(language);
        return localeResult;
    }
}
